import styled from 'styled-components';

const BrandTitle = styled.span`
    font-weight: ${({ theme }) => theme.site.brandTitle.fontWeight};
    text-transform: ${({ theme }) =>
        theme.site.brandTitle.uppercase ? 'uppercase' : 'capitalize'};
`;

export default BrandTitle;
